import React, { useContext } from 'react';
import ConfigContext from '../../../contexts/ConfigContext';

const LiveViewEmployeeTypeChip = ({ value }) => {
  const { t } = useContext(ConfigContext);

  const employeeTypeOptions = [
    { value: 'internal', label: t('internalEmployees') },
    { value: 'external', label: t('externalEmployees') }
  ];

  return (
    <>
      {value
        .map((item) => employeeTypeOptions.find((employeeTypeOption) => employeeTypeOption.value === item)?.label)
        .join(', ')}
    </>
  );
};

export default LiveViewEmployeeTypeChip;
